import React, { ReactNode } from 'react';

export type List = { term: string; definition: ReactNode }[];

function Row({ children }: { children: ReactNode }) {
  return <div className="table-row">{children}</div>;
}

function Term({ children }: { children: ReactNode }) {
  return <dt className="table-cell px-2 py-1 font-bold align-top">{children}</dt>;
}

function Definition({ children }: { children: ReactNode }) {
  return <dd className="table-cell px-2 py-1">{children}</dd>;
}

function SummaryList({ list, children, ...props }: { list: List; children: ReactNode }) {
  return (
    <dl className="table -mx-2" {...props}>
      {list &&
        list.map(item => (
          <Row key={item.term}>
            <Term>{item.term}</Term>
            <Definition>{item.definition}</Definition>
          </Row>
        ))}
      {children}
    </dl>
  );
}

export { SummaryList, Row, Term, Definition };
